import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaHeart, FaPlus, FaTimes, FaCheck, FaArrowUp, FaTrash, FaImage, FaLink } from 'react-icons/fa';
import '../styles/RequestsPage.css';

const API = process.env.REACT_APP_API_URL || '';

function RequestsPage({ user }) {
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const [requests, setRequests] = useState([]);
  const [tab, setTab] = useState('open');
  const [sort, setSort] = useState('votes');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', artist: 'Disney', category: 'film_soundtrack', cover_url: '', description: '' });
  const [message, setMessage] = useState(null);

  useEffect(() => { loadRequests(); }, [tab, sort]);

  const loadRequests = async () => {
    try {
      const res = await axios.get(`${API}/api/requests`, { params: { status: tab, sort } });
      setRequests(res.data);
    } catch (e) {}
  };

  const submitRequest = async () => {
    if (!form.title.trim()) return setMessage({ type: 'error', text: 'Titre requis' });
    try {
      await axios.post(`${API}/api/requests`, form);
      setMessage({ type: 'success', text: 'Requête envoyée !' });
      setForm({ title: '', artist: 'Disney', category: 'film_soundtrack', cover_url: '', description: '' });
      setShowForm(false);
      loadRequests();
    } catch (e) {
      setMessage({ type: 'error', text: e.response?.data?.error || 'Erreur' });
    }
  };

  const vote = async (id) => {
    try {
      await axios.post(`${API}/api/requests/${id}/vote`);
      loadRequests();
    } catch (e) {}
  };

  const fulfill = async (id) => {
    if (!window.confirm('Marquer cette requête comme satisfaite ?')) return;
    try {
      await axios.put(`${API}/api/requests/${id}/fulfill`, {});
      loadRequests();
    } catch (e) { alert(e.response?.data?.error || 'Erreur'); }
  };

  const closeRequest = async (id) => {
    if (!window.confirm('Fermer cette requête ?')) return;
    try {
      await axios.put(`${API}/api/requests/${id}/close`);
      loadRequests();
    } catch (e) {}
  };

  const deleteRequest = async (id) => {
    if (!window.confirm('Supprimer cette requête ?')) return;
    try {
      await axios.delete(`${API}/api/requests/${id}`);
      loadRequests();
    } catch (e) {}
  };

  return (
    <div className="requests-page">
      <div className="requests-header">
        <h1>📋 Requêtes d'albums</h1>
        <button className="new-request-btn" onClick={() => setShowForm(!showForm)}>
          {showForm ? <><FaTimes /> Annuler</> : <><FaPlus /> Demander un album</>}
        </button>
      </div>

      {showForm && (
        <div className="request-form">
          <h3>Quel album aimeriez-vous voir ajouté ?</h3>
          <div className="form-grid">
            <div className="form-main">
              <input value={form.title} onChange={e => setForm({...form, title: e.target.value})}
                placeholder="Titre de l'album *" />
              <input value={form.artist} onChange={e => setForm({...form, artist: e.target.value})}
                placeholder="Artiste" />
              <select value={form.category} onChange={e => setForm({...form, category: e.target.value})}>
                <option value="film_soundtrack">BO de Film</option>
                <option value="disney_park">Disney Park</option>
                <option value="public_album">Album Grand Public</option>
              </select>
              <div className="form-cover-url">
                <FaLink className="form-icon" />
                <input value={form.cover_url} onChange={e => setForm({...form, cover_url: e.target.value})}
                  placeholder="Lien pochette (optionnel)" />
              </div>
              <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})}
                placeholder="Description, infos utiles... (optionnel)" rows={3} />
            </div>
            {form.cover_url && (
              <div className="form-cover-preview">
                <img src={form.cover_url} alt="" onError={e => e.target.style.display='none'} />
              </div>
            )}
          </div>
          {message && <div className={`request-message ${message.type}`}>{message.text}</div>}
          <button className="submit-request-btn" onClick={submitRequest}>
            <FaPlus /> Soumettre la requête
          </button>
        </div>
      )}

      <div className="requests-controls">
        <div className="requests-tabs">
          <button className={tab === 'open' ? 'active' : ''} onClick={() => setTab('open')}>
            En attente
          </button>
          <button className={tab === 'fulfilled' ? 'active' : ''} onClick={() => setTab('fulfilled')}>
            ✅ Satisfaites
          </button>
          {isAdmin && (
            <button className={tab === 'closed' ? 'active' : ''} onClick={() => setTab('closed')}>
              Fermées
            </button>
          )}
        </div>
        <div className="requests-sort">
          <button className={sort === 'votes' ? 'active' : ''} onClick={() => setSort('votes')}>
            🔥 Populaires
          </button>
          <button className={sort === 'recent' ? 'active' : ''} onClick={() => setSort('recent')}>
            🕐 Récentes
          </button>
        </div>
      </div>

      <div className="requests-list">
        {requests.length === 0 ? (
          <div className="requests-empty">
            {tab === 'open' ? 'Aucune requête en cours. Soyez le premier !' : 'Rien ici.'}
          </div>
        ) : requests.map(r => (
          <div key={r.id} className={`request-card ${tab}`}>
            <div className="request-vote" onClick={() => tab === 'open' && vote(r.id)}>
              <FaArrowUp className={`vote-arrow ${r.user_voted ? 'voted' : ''}`} />
              <span className={`vote-count ${r.user_voted ? 'voted' : ''}`}>{r.votes}</span>
            </div>
            {r.cover_url && (
              <img src={r.cover_url} alt="" className="request-cover" onError={e => e.target.style.display='none'} />
            )}
            <div className="request-info">
              <div className="request-title">{r.title}</div>
              <div className="request-artist">{r.artist} • {r.category === 'film_soundtrack' ? 'BO Film' : r.category === 'disney_park' ? 'Parc Disney' : 'Album'}</div>
              {r.description && <div className="request-desc">{r.description}</div>}
              <div className="request-meta">
                Demandé par <strong>{r.display_name || r.username}</strong> • {new Date(r.created_at).toLocaleDateString('fr-FR')}
              </div>
            </div>
            <div className="request-actions">
              {isAdmin && tab === 'open' && (
                <>
                  <button className="action-fulfill" onClick={() => fulfill(r.id)} title="Marquer comme satisfaite"><FaCheck /></button>
                  <button className="action-close" onClick={() => closeRequest(r.id)} title="Fermer"><FaTimes /></button>
                </>
              )}
              {(r.user_id === user?.id || isAdmin) && (
                <button className="action-delete" onClick={() => deleteRequest(r.id)} title="Supprimer"><FaTrash /></button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RequestsPage;
